
































































































































































































































































































































import { Component, Vue } from "vue-property-decorator"
import { ProfileService } from "../services/profile.service"
import { router } from "@/router"

@Component({
  components: {},
})
export default class Profile extends Vue {
  user: any = {}
  selectedYear: any = 2018
  historicoSume: any = []
  historicoSumeFiltro: any = []
  items: string[] = ["perfil", "Educación Continua (Completados)"]

  selectedHistorial = "sume"
  goTo = (route: string) => router.push(route)

  baseEmail = (email: string): string => email.split("@")[0]

  async created() {
    this.user = this.getUser()
    //"mtinajero"
    this.historicoSume = await ProfileService.getCursosNodo(
      this.baseEmail(this.user.email)
    ) //cambiar valor
  }

  getUser = () => JSON.parse(localStorage.getItem("user") as string)
}
